import React from 'react';

function SectionHeader({ title, right = null, className = '' }) {
  const classes = ['row-between', className].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      <h3 className="section-title">{title}</h3>
      {right}
    </div>
  );
}

export default SectionHeader;
